<div class="widget-container">
  <div *ngFor="let i of data; trackById">
    <button class="btn box bg-secondary" (click)="alert(i)">
      {{ i }}
    </button>
  </div>
</div>